// extracted by mini-css-extract-plugin
export var overview = "ProjectOverview-module--overview--RXun2";
export var previewImage = "ProjectOverview-module--previewImage--O97mG";